import React from 'react'
import { ErrorGroup, isErrorGroupAcknowledgable } from '../domain/Error'

interface Props {
    errorGroup: ErrorGroup
    compact?: boolean
}
export class AcknowledgedLabel extends React.PureComponent<Props> {
    defaultProps = {
        compact: false,
    }

    public render = () =>
        isErrorGroupAcknowledgable(this.props.errorGroup) ? (
            this.props.errorGroup.acknowledged ? (
                <span
                    className="label label-success tw-tooltip tw-tooltip-dataText tw-tooltip--top"
                    data-tooltip-text="Error has been acknowledged, no repeating notifications will be sent."
                >
                    <i className="fa fa-check" />
                    {this.props.compact ? '' : ' Acknowledged'}
                </span>
            ) : this.props.compact ? null : (
                <span className="label label-default">Unacknowledged</span>
            )
        ) : null
}
